import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { PaymentPlanPopupComponent } from 'src/app/core/modals/payment-plan-popup/payment-plan-popup.component';
import { ShippingService } from 'src/app/core/services/api-services/shipping.service';

@Component({
  selector: 'app-add-rx-modal',
  templateUrl: './add-rx-modal.component.html',
  styleUrl: './add-rx-modal.component.scss',
  providers: [DatePipe]
})
export class AddRxModalComponent implements OnInit {
  rxForm: FormGroup | any;
  verify_rx_btn = false;
  rx_details:any=[];
  isSaveRXLoading = false;
  constructor(
    public dialogRef: MatDialogRef<PaymentPlanPopupComponent>,
    private shippingService: ShippingService,
    private fb: FormBuilder,
    public toastr: ToastrService,
    private datePipe: DatePipe,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any
  ) {}

  ngOnInit(): void {    
    this.rxForm = this.fb.group({
      rxId: ['', Validators.required],
      qnt: [''],
      drgName: [''],
      din: [''],
      fillDate: [''],
    });
  }

  verifyRXDetail() {
    if (this.rxForm.invalid) return this.rxForm.markAllAsTouched(); 
    this.verify_rx_btn = true;
    const payload = {
      user_visit_id: this.props?.item?.visitId,
      search_value: this.rxForm.value.rxId,
    };

    this.shippingService.verify_rx_before_create(payload).subscribe(
      (res) => {
        this.verify_rx_btn = false;
        if (res?.body?.success) {
          this.rx_details = res?.body?.data?.rx_details;
          this.rxForm.patchValue({
            qnt: res?.body?.data?.rx_details[0]?.kroll_rx[0]?.DispQty,
            drgName: res?.body?.data?.rx_details[0]?.kroll_rx[0]?.kroll_drg?.GenericName,
            din: res?.body?.data?.rx_details[0]?.kroll_rx[0]?.kroll_drg?.DIN,
            fillDate: res?.body?.data?.rx_details[0]?.kroll_rx[0]?.FillDate.split(' ')[0],
          })
          this.toastr.success(res?.body?.message)
        }else{
          // this.rxForm.reset();
          this.toastr.error(res?.body?.message)
        } 
      },
      (error) => {
        this.verify_rx_btn = false;
      }
    );
  }

  addRxDetails() {
    this.isSaveRXLoading = true;
    if (this.rxForm.invalid) return this.rxForm.markAllAsTouched();
    this.verify_rx_btn = true;
    const payload = {
      SalesOrderID: this.props?.item?.ID,
      RxNum: this.rxForm.value.rxId,
      rx_details: this.rx_details[0]?.kroll_rx,
    };

    this.shippingService.save_rx_for_draft(payload).subscribe(
      (res) => {
        this.isSaveRXLoading = false;
        this.verify_rx_btn = false;
        if (res?.body?.success) {
          this.dialogRef.close(res);
          this.toastr.success(res?.body?.message)
        } else {
          this.toastr.error(res?.body?.message)
        }
      },
      (error) => {
        this.isSaveRXLoading = false;
        this.verify_rx_btn = false;
      }
    );
  }

  get isSaveRxDetails() {
    return this.rxForm.value.rxId == '' || this.rxForm.value.qnt == '' || this.rxForm.value.drgName == '' || this.rxForm.value.din == '' || this.rxForm.value.fillDate == ''
  }

  keyPressNumbers(event: any) {
    var charCode = event.which ? event.which : event.keyCode;
    // Only Numbers 0-9
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
}
